import React from "react";
import { Typography, Box, Button, Paper, Divider } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface ProcessedLeadViewProps {
  processedLead: any;
  onEdit: () => void;
  onFollowUp: (months: number) => void;
}

const ProcessedLeadView: React.FC<ProcessedLeadViewProps> = ({
  processedLead,
  onEdit,
  onFollowUp,
}) => {
  if (!processedLead) return null;

  return (
    <Paper
      elevation={3}
      sx={{
        padding: 3,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          gap: 1,
          mb: 2,
        }}
      >
        <Button variant="contained" onClick={() => onFollowUp(1)}>
          Follow up in 1 month
        </Button>
        <Button variant="contained" onClick={() => onFollowUp(3)}>
          Follow up in 3 months
        </Button>
        <Button variant="outlined" startIcon={<EditIcon />} onClick={onEdit}>
          Edit
        </Button>
      </Box>

      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {processedLead.company}
      </Typography>

      <Divider sx={{ marginBottom: 2 }} />

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 1 }}>
        <Typography variant="body1">
          <strong>Power Units:</strong> {processedLead.powerUnits}
        </Typography>
        <Typography variant="body1">
          <strong>Trailer Units:</strong> {processedLead.trailerUnits}
        </Typography>
        <Typography variant="body1">
          <strong>Address:</strong> {processedLead.address}
        </Typography>
        <Typography variant="body1">
          <strong>City:</strong> {processedLead.city}
        </Typography>
        <Typography variant="body1">
          <strong>State:</strong>{" "}
          {processedLead.state && processedLead.state.toUpperCase()}
        </Typography>
        <Typography variant="body1">
          <strong>Zip:</strong> {processedLead.zip}
        </Typography>
        <Typography variant="body1">
          <strong>Contact Name:</strong> {processedLead.contactName}
        </Typography>
        <Typography variant="body1">
          <strong>Direct Phone:</strong> {processedLead.directPhone}
        </Typography>
        <Typography variant="body1">
          <strong>Fax:</strong> {processedLead.fax}
        </Typography>
        <Typography variant="body1">
          <strong>Email:</strong> {processedLead.email}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ProcessedLeadView;
